module.exports = __webpack_public_path__ + "static/media/trending-screen.d9865a75.png";